import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { t } from '../../translation'

import AsideInstruments from './AsideInstruments'

const AsideDescription = ({ description, instruments }) => (
  <Fragment>
    <div className="description_item">
      <div className="description_title">{t('player.DESCRIPTION')}: </div>
      <div className="description_text">{description}</div>
    </div>
    <AsideInstruments instruments={instruments} />
  </Fragment>
)

export default AsideDescription

AsideDescription.propTypes = {
  description: PropTypes.string.isRequired,
  instruments: PropTypes.arrayOf(PropTypes.string),
}
